import { CircularProgress } from '@material-ui/core'
import './circularSpinner.scss'

const CircularSpinner = ({ size, color }) => {
  return (
    <CircularProgress
      className={` circular-spinner-container ${color} `}
      size={size}
    />
  )
}

export default CircularSpinner
